<div class="canvas-wrapper"
	#canvasWrapper
	[class.dragging-canvas]="draggingCanvas"
	[style.visibility]="designWidth ? 'visible' : 'hidden'"
	(click)="onCanvasClick($event)"
	(wheel)="onMouseWheel($event)"
	(mousedown)="onCanvasMouseDown($event)"
	(scroll)="onScroll($event)"
	(contextmenu)="onStageContextMenu($event)"
	[class.dragging-over]="draggingOver"
>
	<div class="custom-warning" >
		<span *ngIf="preloadedWidgets > 50 && !forceClosed" class="message warning ng-binding">
			<i class="fa fa-warning"></i> {{ 'WIDGET_PRELOAD_PERFORMANCE' | translate }}
			<i class="fa-regular fa-circle-xmark" (click)="closeWarning()"></i>
		</span>
	</div>

		<div 	class="stage-content-wrapper"
				#stage 
				[style.width]="stageWidth + 'px'"
				[style.height]="stageHeight + 'px'"
				(dragover)="onStageDragover($event)"
				(dragleave)="onStageDragleave()"
				(drop)="onStageDrop($event)"
		>
			<div
				class="media-element"
				#mediaWrapper
				[style.left]="mediaOffsetX + 'px'"
				[style.top]="mediaOffsetY + 'px'"
				[style.width]="designWidth + 'px'"
				[style.height]="designHeight + 'px'"
			>
				<player *ngIf="interactivityEditorService.parentEntityType === 'MediaClip'"></player>
				<div class="app-dimensions-area" *ngIf="interactivityEditorService.parentEntityType === 'App' || interactivityEditorService.parentEntityType === 'Project'"></div>

			</div>
			<div
				class="stage-overlay"
				[ngStyle]="getOverlayStyle()"
			></div>
		
			<div id="widgetSelector" class="widget-selector" #widgetSelector></div>
		
			<grid-visual #vGrid ></grid-visual>
			
			<!-- Used to debug snapping, or to visualise later (zooming is a bit off when using these, review that if ever needed): -->
			<!-- <div class="snap-lines" *ngIf="false && useSnapping">
				<ng-container *ngFor="let sp of snappingTargets; let i = index">
					<div class="snapping-target snapping-line"
						*ngIf="!(sp.x && sp.y) && (sp.x || sp.y)"
						[style.left]="(sp.x ? sp.x : 0) + 'px'"
						[style.top]="(sp.y ? sp.y : 0) + 'px'"
						[style.width]="(sp.x ? 1 : stageWidth) + 'px'"
						[style.height]="(sp.y ? 1 : stageHeight) + 'px'"
					></div>
					
					<div class="snapping-target snapping-point"
						*ngIf="sp.x && sp.y"
						[style.left]="sp.x + 'px'"
						[style.top]="sp.y + 'px'"
					></div>
				</ng-container>
			</div> -->

			<ng-container *ngFor="let widget of widgets; let i = index">
				<!-- interactDraggable
					[disableDrag]="widgetEditMode || widget?.type === 'app'"
					[interactOptions]="interactOptions"
					[interactSnapObjectSubject]="snapObjectSubject"
					(interactDragStart)="onWidgetDragStart(widget, $event)"
					(interactDragging)="onWidgetDragging(widget, $event)"
					(interactDragEnd)="onWidgetDragEnd(widget, $event)"
					 -->
					 <!-- interactResizable
					[interactOptionsResizable]="interactOptionsResizable"
					[interactOptionsResizableSubject]="interactOptionsResizableSubject"
					(interactResizeEnd)="onWidgetResizeEnd(widget, $event)" -->
				<stage-widget
					(contextmenu)="onWidgetContextMenu($event, widget)"
					(editModeChanged)="onWidgetEditModeChanged(widget, $event)"
					(mouseover)="onWidgetMouseOver(widget, $event)"
					(mouseleave)="onWidgetMouseLeave(widget, $event)"
					bbDrag
					[bbDragUseSnapping]="useSnapping"
					[bbDragSnapCoords]="snappingTargets"
					[bbDragContainer]="stage"
					[bbDragRelativeSnapPoints]="relativeSnapPoints"
					[bbDragShowSnapGuides]="true"
					(bbDragStarted)="onWidgetDragStart(widget, $event)"
					(bbDragMoved)="onWidgetDragging(widget, $event)"
					(bbDragEnded)="onWidgetDragEnd(widget, $event)"
					bbResize
					(bbResizeStarted)="onWidgetResizeStart(widget, $event)"
					(bbResizeEnded)="onWidgetResizeEnd(widget, $event)"
					[bbResizeSnapCoords]="snappingTargets"
					[bbResizeUseSnapping]="useSnapping"
					[bbResizeShowSnapGuides]="true"
					[bbResizeContainer]="stage"
					[bbResizeDisabled]="widget?.type === 'app' || widget?.fromAppId"
					[bbResizeHandles]="resizeHandles"
					[bbResizeLockAspectRatio]="interactivityWidgetService?.aspectRatioLocked"
					[class.selected]="widget.isSelected"
					[class.is-hovered]="isWidgetHovered(widget)"
					(click)="onWidgetClick($event, widget)"
					(mousedown)="onWidgetMouseDown($event, widget)"
					(mouseup)="onWidgetMouseUp($event, widget)"
					[ngClass]="'widget-type-' + widget?.type + ( widget?.fromAppId ? ' from-app' : '')"
					[style.z-index]="i"
					[style.left]="pct2px(widget.calculatedConfig.xpos, 'xpos', appWidgetsById[widget.fromAppId])"
					[style.top]="pct2px(widget.calculatedConfig.ypos, 'ypos', appWidgetsById[widget.fromAppId])"
					[style.width]="widget?.type === 'app' ? (designWidth + 'px') : pct2px(widget.calculatedConfig.width, 'width')"
					[style.height]="widget?.type === 'app' ? (designHeight + 'px') : pct2px(widget.calculatedConfig.height, 'height')"
					[style.pointer-events]="widget?.type === 'app' ? 'none' : 'all'"
					[style.visibility]="widget?.visibility"
					[widget]="widget"
					[isHovered]="isWidgetHovered(widget)"
					*ngIf="isStageWidget(widget) && !(interactivityEditorService.isTimeBased && currentlyInTimeWidgetIds.indexOf(widget.id) === -1)">
					<div class="widget-overlay"></div>
					<!-- ngIf on bb-resize-handles causes [bbResizeHandles]="resizeHandles" not to work -->
					<!-- *ngIf="widget?.type !== 'app' && ! widget?.fromAppId" -->
					<bb-resize-handles
						[hidden]="widget?.type === 'app' || widget?.fromAppId"
						#resizeHandles
						(mousedown)="onResizeHandlerMouseDown($event)"
					></bb-resize-handles>
				</stage-widget>
			</ng-container>
		</div>
	<div class="zoom-bar" [style.z-index]="widgets.length + 2">
		<div class="ie-icon-button" (click)="zoom('out')" [title]="'ZOOM_OUT' | translate">-</div>
		<div class="zoom-icon ie-icon-display" (click)="zoom('toFit')" [title]="'ZOOM_TO_FIT' | translate">
			<i class="fa fa-search"></i>
		</div>
		<div class="ie-icon-button" (click)="zoom('in')" [title]="'ZOOM_IN' | translate">+</div>
	</div>
	<div class="drop-zone" [style.z-index]="widgets.length + 3"></div>
	<bb-context-menu [ngStyle]="contextMenuStyle" [themeName]="'dark-theme'" [options]="contextMenuOptions" (optionSelected)="onContextMenuOptionSelected($event)" (clickOutside)="contextMenuHide()"></bb-context-menu>
</div>

<ng-template #designDimensionsTemplate>
	<ie-design-dimensions [modal]="designDimensionsModal" [isApp]="interactivityEditorService.parentEntityType === 'App'"></ie-design-dimensions>
</ng-template>
